/** Live Firestore sync for application list rows — disable via env for debugging. */
export function isApplicationLiveSyncEnabled(): boolean {
  const raw = import.meta.env.VITE_APPLICATION_LIVE_SYNC as string | undefined;
  if (raw === 'false' || raw === '0') return false;
  return true;
}

export type ApplicationLiveSyncHealth = 'idle' | 'connected' | 'degraded';

let health: ApplicationLiveSyncHealth = 'idle';

export function getApplicationLiveSyncHealth(): ApplicationLiveSyncHealth {
  return health;
}

export function setApplicationLiveSyncHealth(next: ApplicationLiveSyncHealth): void {
  health = next;
}

/** Poll fallback runs when live sync is off or Firestore listeners are degraded. */
export function shouldUsePipelineStatusPollFallback(): boolean {
  if (!isApplicationLiveSyncEnabled()) return true;
  return getApplicationLiveSyncHealth() === 'degraded';
}
